<template>
  <div class="filtered-courses">
    <course-tile
      v-for="course in courses"
      :key="course.id"
      :course="course"
      :backgroundImg="$getCourseBackground(course, 'small')"
      :gradient="$getGradient()"
      :duration="$duration.getCourseDuration(course)"
      :categoryName="categoryName"
      :customClass="`filtered-courses__course`"
    ></course-tile>
  </div>
</template>

<script>
import CourseTile from '@/components/layout/CourseTile.vue'

export default {
  name: 'FilteredCourses',
  components: {
    CourseTile,
  },
  props: {
    courses: {
      type: Array,
      required: true,
    },
    categoryName: {
      type: String,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.filtered-courses {
  display: flex;
  flex-wrap: wrap;
  z-index: 2;
  min-width: 100%;
  &__course {
    width: 100%;
    flex-grow: 1;
    @include mobile {
      width: 100%;
    }
    @include tablet {
      width: 50%;
    }
    @include desktop {
      width: 25%;
    }
    @include lg-desktop {
      width: 15%;
    }
  }
}
</style>
